const SessionManager = {

    getToken() {
        const token = sessionStorage.getItem('token');
        if (token) return token;
        else return null;
    },

    getUserName() {
        const username = sessionStorage.getItem('userName');
        if (username) return username;
        else return null;
    },

    setUserSession(token, userName) {       
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('userName', userName);
    },

    removeUserSession() {
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('token');
    }
}

export default SessionManager;